/**
 * Очередь полноэкранных «моментов»: рекап отбора должен показываться ПОСЛЕ
 * листов достижений и повышения уровня (хэндофф: «отдельный шаг после
 * ачивок»). Листы сами по себе стакаются без координации — каждый источник
 * репортит сюда pending/idle, рекап ждёт allIdle.
 */
import { useSyncExternalStore } from 'react';

const pending = new Set<string>();
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

/** Источник (achievements | rating) сообщает, показывает ли он что-то сейчас. */
export function setCelebrationPending(source: string, isPending: boolean) {
  const had = pending.has(source);
  if (isPending === had) return;
  if (isPending) pending.add(source);
  else pending.delete(source);
  emit();
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useCelebrationsIdle(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => pending.size === 0,
    () => true,
  );
}

/** Ждать конкретный источник: лист уровня рейтинга выходит ПОСЛЕ листов
 *  достижений (иначе они стакаются друг на друга — фикс 26.09). */
export function useCelebrationSourceIdle(source: string): boolean {
  return useSyncExternalStore(
    subscribe,
    () => !pending.has(source),
    () => true,
  );
}
